import LegalDocumentPage from "@/components/LegalDocumentPage";

export default function CookiesPage() {
  return <LegalDocumentPage docType="cookies" testId="cookies-page" />;
}
